import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { Bell, Flame, UserPlus, Rocket, X } from "lucide-react";

const ICON = { hot_lead: Flame, priority: Flame, assignment: UserPlus, campaign_promoted: Rocket };

export default function NotificationTray() {
  const [data, setData] = useState({ items: [], unread: 0 });
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const nav = useNavigate();

  const load = () => api.get("/notifications").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, []);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const openItem = async (n) => {
    if (!n.read) { await api.post(`/notifications/${n.id}/read`); load(); }
    setOpen(false);
    if (n.lead_id) nav(`/leads/${n.lead_id}`);
    else nav("/linkedin");
  };
  const readAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <div className="relative" ref={ref}>
      <button onClick={() => setOpen((o) => !o)} data-testid="notif-bell"
        className="relative p-2 hover:bg-[#EFECE5] border border-[#DFDAD0]">
        <Bell className="w-4 h-4 text-[#1C2530]" strokeWidth={1.5} />
        {data.unread > 0 && (
          <span data-testid="notif-badge" className="absolute -top-1.5 -right-1.5 bg-[#B23A2E] text-white font-mono text-[9px] min-w-[16px] h-4 px-1 flex items-center justify-center rounded-full">
            {data.unread}
          </span>
        )}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-80 bg-white border border-[#DFDAD0] shadow-[3px_3px_0px_#DFDAD0] z-50" data-testid="notif-tray">
          <div className="flex items-center justify-between px-3 py-2 border-b border-[#DFDAD0]">
            <span className="font-mono text-[10px] uppercase tracking-wider text-[#1C2530]/60">Notifications</span>
            <button onClick={readAll} className="font-mono text-[9px] uppercase text-[#3E8F99] hover:underline">mark all read</button>
          </div>
          <div className="max-h-96 overflow-auto">
            {data.items.length === 0 ? (
              <div className="p-6 text-center font-mono text-xs text-[#1C2530]/40">NO_NOTIFICATIONS</div>
            ) : data.items.map((n) => {
              const Icon = ICON[n.type] || Bell;
              return (
                <button key={n.id} onClick={() => openItem(n)} data-testid={`notif-item-${n.id}`}
                  className={`w-full text-left flex gap-2 px-3 py-2.5 border-b border-[#DFDAD0] hover:bg-[#EFECE5] ${n.read ? "opacity-60" : ""}`}>
                  <Icon className="w-4 h-4 mt-0.5 shrink-0" style={{ color: n.type === "priority" || n.type === "hot_lead" ? "#B23A2E" : "#3E8F99" }} strokeWidth={1.75} />
                  <div className="min-w-0">
                    <div className="text-xs font-medium text-[#1C2530] flex items-center gap-1">{n.title}{!n.read && <span className="w-1.5 h-1.5 bg-[#B23A2E] rounded-full" />}</div>
                    <div className="text-[11px] text-[#1C2530]/60">{n.body}</div>
                    <div className="font-mono text-[9px] text-[#1C2530]/40 mt-0.5">{new Date(n.created_at).toLocaleString()}</div>
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
